import React, { useState } from 'react';
import clsx from 'clsx';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import Drawer from '@material-ui/core/Drawer';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Logout from '../../Logout/Logout';

import MenuItems from '../../Dashboard/MenuItems';

const AppBarCustom = props => {
  const [open, setOpen] = useState(true);
  const { classes } = props;

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <AppBar
        position="absolute"
        className={clsx(
          classes.appBar,
          open && classes.appBarShift,
        )}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(
              classes.menuButton,
              open && classes.menuButtonHidden,
            )}
          >
            <MenuIcon />
          </IconButton>
                    <img
            src="/slogan-web-2026-white.png"
            className={classes.imgSlogan}
            alt="LogoPLN"
          />
          <Typography
            component="h6"
            variant="h6"
            color="white"
            noWrap
            className={classes.title}
          >
            ELECTORALES 2026
          </Typography>
          <Logout />
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(
            classes.drawerPaper,
            !open && classes.drawerPaperClose,
          ),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <img
            src="/logo-web-2026-full.png"
            className={classes.imgLogo}
            alt="LogoPLN"
          />

          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <MenuItems />
        <Divider />
      </Drawer>
    </React.Fragment>
  );
};

export default AppBarCustom;
